{
  "back": "Kembali",
  "form": "Borang",
  "purposeTitle": "Apakah tujuan pemberhentian anda?",
  "appointmentInfoTitle": "Maklumat temu janji",
  "appointmentInfoHint": "Pastikan anda mengisi ruangan ini jika anda mempunyai temu janji.",
  "checkInDetailsTitle": "Butiran Daftar Masuk",
  "checkInDetailsHint": "Maklumat tambahan mengenai lawatan anda.",
  "driverPhoneLabel": "Nombor Telefon Pemandu",
  "activateWhatsAppTitle": "Aktifkan Mesej WhatsApp",
  "activateWhatsAppBody": "Untuk berbual dengan gudang, sila balas \"OK\" apabila kami menghantar mesej WhatsApp pertama kepada anda.",
  "whatsappDelayBanner": "Mesej WhatsApp pertama mungkin mengambil masa sehingga satu minit untuk sampai.",
  "notesLabel": "Nota",
  "notesPlaceholder": "Sebarang arahan khas atau nota untuk kemudahan ini?",
  "addNoteToWarehouse": "Tambah nota untuk gudang",
  "verifyAndCheckIn": "Sahkan dan daftar masuk",
  "completeCheckIn": "Lengkapkan daftar masuk",
  "visitGroupInbound": "Masuk",
  "visitGroupOutbound": "Keluar",
  "visitGroupBoth": "Masuk & Keluar",
  "visitUnloadTruck": "Memunggah trak saya",
  "visitDropTrailer": "Lepaskan treler atau kontena saya",
  "visitLoadTruck": "Muatkan trak saya",
  "visitHookTrailer": "Kaitkan treler atau kontena",
  "visitUnloadLoad": "Memunggah & Memuatkan trak saya",
  "visitDropHook": "Lepaskan & Kaitkan treler atau kontena",
  "containerTrailer": "Treler",
  "containerContainer": "Kontena",
  "containerOversized": "Bersaiz Melebihi Had",
  "containerOther": "Lain-lain",
  "defaultReferenceName": "Nombor PO",
  "identifierSuffix": "{reference} atau Nombor Pengesahan",
  "licenseOrDotRequired": "Sila isikan Plat Lesen atau Nombor DOT",
  "appointmentNotFound": "Kami tidak dapat mengesan temu janji anda",
  "referenceNotFound": "Tiada temu janji sepadan ditemui. Nombor rujukan adalah sensitif huruf besar/kecil.",
  "referenceCaseSensitiveHint": "Nombor rujukan adalah sensitif huruf besar/kecil",
  "messaging": {
    "whatsappFailedTitle": "Tidak dapat menghantar mesej WhatsApp",
    "smsFailedTitle": "Tidak dapat menghantar mesej SMS",
    "whatsappFailedBody": "Kami tidak dapat menghantar mesej kepada {displayPhone}. <br /><br /> Jika anda pernah nyah-langgan sebelum ini, sila hantar SMS START ke <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a> untuk mula menerima mesej daripada gudang ini.",
    "smsFailedBody": "Kami tidak dapat menghantar mesej kepada {displayPhone}. <br /><br /> Jika anda pernah nyah-langgan sebelum ini, sila hantar SMS START ke <a href='{smsUrl}'>{senderPhone}</a> untuk mula menerima mesej SMS daripada gudang ini.",
    "fallbackPhone": "nombor telefon yang diberikan"
  }
}
